import { createSlice } from "@reduxjs/toolkit";

const initialIntegrationState = {
  listLoading: false,
  actionsLoading: false,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const integrationSlice = createSlice({
  name: "integrations",
  initialState: initialIntegrationState,
  reducers: {
    endCall: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  },
});
